<!--US Page-->
<div class="dtfinsurance" *ngIf="!isCanadaPortal">
  <!--Announcement Banner Code-->
  <!-- <div class="dtf-alertpage"></div> -->


  <!--Banner-->
  <section class="mbfs-home-hero_2"
  style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_DI-carousel_1140x400px_1123.jpg);">
  <section class="mbfs-home-hero_2__header">
    <div class="shortrow">
      <div>
      <h2 class="mbfs-home-hero_2__header-subtitle">
        {{ 'DynamicPortal.TruckTitleInsurance' | translate }}
      </h2>
      <p class="mbfs-home-hero_2__header-text">
        {{ 'DynamicPortal.TruckHeaderInsurance' | translate }}
      </p>
    </div>
      <div class="dtf-dynamicinsuranceformpage"></div>
   </div>
  </section>
</section>

  <section class='mbfs-repay-banner-inner'>
    <div class="mbfs-repay-banner-inner__box">
      <div class="mbfs-repay-banner-inner__box--text2">
        <h2 class="mbfs-repay-banner-inner__header-title">
          {{ 'DynamicPortal.InsuranceHeaderInsurance' | translate }}
        </h2>
        <p class="mbfs-repay-banner-inner__header-text2">{{ 'DynamicPortal.InsuranceCopy1Insurance' | translate }}</p>
      </div>
    </div>
  </section>

  <!--Benefits you can count on 1-->
  <div class="mercedes-me-login__column">
    <h2 class="mercedes-me-login__column-headline"></h2>
    <ul class="dtfbrochures__columns2">
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/COMPETITIVE_PRICING_Icon.png">
        <h4 class="header1"> {{ 'DynamicPortal.BenefitsTitle1Insurance' | translate }}</h4>
        <p class="paragraph1"> {{ 'DynamicPortal.BenefitsCopy1Insurance' | translate }}</p>
      </li>
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/SAFETY_DISCOUNTS_Icon.png">
        <h4 class="header1"> {{ 'DynamicPortal.BenefitsTitle2Insurance' | translate }}</h4>
        <p class="paragraph1"> {{ 'DynamicPortal.BenefitsCopy2Insurance' | translate }}</p>
      </li>
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/TOOLS_AND_RESOURCES_Icon.png">
        <h4 class="header1">{{ 'DynamicPortal.BenefitsTitle3Insurance' | translate }}</h4>
        <p class="paragraph1">{{ 'DynamicPortal.BenefitsCopy3Insurance' | translate }}</p>
      </li>
    </ul>
  </div>

  <!-- Protect Your investment-->
  <div class="dtfbrochures__page3">
    <div class="dtfbrochures__container2">
      <h4 class="dtfbrochures__header2">{{ 'DynamicPortal.FinancingHeaderInsurance' | translate }}</h4>
      <p class="dtfbrochures__paragraph3">
        {{ 'DynamicPortal.FinancingParagraphInsurance' | translate }}
        <a class="dtfbrochures__hrefGreen"  href="https://hdvi.com/agents/#map" target="_blank"> {{ 'DynamicPortal.FinancingParagraphHref' | translate }}</a>.
      </p>      
      <a target="_blank" class="mbfs-button" href="static/assets/pdf/DTF_DI_Brochure_092822_Digital.pdf">{{ 'DynamicPortal.DYIBrochureButton' | translate }}</a>
      <br><br>
    <div class="dtfbrochures__columns2">
      <div class="row5">
         <div class="col-sm-4">
            <img class ="smallimg2" src="static/assets/img/dtf-assets/images/redesign/FLEET_SIZE.png">
            <!-- <h4> {{ 'DynamicPortal.FinancingTitle1Insurance' | translate }}</h4> -->
            <!-- <p class="paragraph2"> {{ 'DynamicPortal.FinancingCopy1Insurance' | translate }}</p> -->
          </div>
         <div class="col-sm-4">
            <img class ="smallimg2" src="static/assets/img/dtf-assets/images/redesign/OPERATION_TYPE.png">
            <!-- <h4> {{ 'DynamicPortal.FinancingTitle2Insurance' | translate }}</h4> -->
            <!-- <p class="paragraph2"> {{ 'DynamicPortal.FinancingCopy2Insurance' | translate }}</p> -->
         </div>
         <div class="col-sm-4">
          <img class ="smallimg2" src="static/assets/img/dtf-assets/images/redesign/VEHICLE_CLASS.png">
          <!-- <h4> {{ 'DynamicPortal.FinancingTitle3Insurance' | translate }}</h4> -->
          <!-- <p class="paragraph2"> {{ 'DynamicPortal.FinancingCopy3Insurance' | translate }}</p> -->
         </div>
      </div>
      </div>
      <br><br>
      <!-- <p class="dtfbrochures__paragraph3"> {{ 'DynamicPortal.DisclaimerItalicsInsurance' | translate }}</p>       -->
      <p class="dtfbrochures__paragraph4"> {{ 'DynamicPortal.DYIsmallParagraph' | translate }}</p>
  </div>

  <!-- <section class='mbfs-red-banner-inner'>
    <div class="mbfs-red-banner-inner__box">
      <div class="mbfs-red-banner-inner__box--text">
        <h2 class="mbfs-red-banner-inner__header-title">
          For more information
          <a href="/home/brochures">click here</a>
          to review our brochures or <a href="{{this.targetRedirect}}en/calculator/findealer.do"> {{
            'Header.FindADealer' | translate }}</a>
        </h2>
      </div>
    </div>
  </section> -->

  <!-- <div class="mercedes-me-login__column_left">
    <h2 class="mercedes-me-login__column_left-headline">Request More Information</h2>
    <p class="mercedes-me-login__column_left-paragraph">To Learn more and to see how Dynamic Insurance can benefit your business, please fill out the information below and click submit. <span class ="mercedes-me-login__column_left-span">(*) Required information</span></p>
    <p class="mercedes-me-login__column_left-paragraph_red">Thank you for your interest in Dynamic Insurance. You will be contacted by a representative shortly.</p>
  </div> -->

  <!--Copyright footer-->
  <footer id="mbfs-footer">
    <div role="contentinfo">
      <div class="mbfs-copyright">
        <p class="paragraph1"> {{ 'DynamicPortal.DisclaimerInsurance' | translate }} </p>
        <p class="paragraph1"> {{ 'DynamicPortal.Disclaimer2Insurance' | translate }} </p>        
      </div>
    </div>
  </footer>
</div>
</div>
